export default __webpack_public_path__ + "static/media/options.227aa29e.svg";